import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Radio from '@material-ui/core/Radio';
import Button from '@material-ui/core/Button';
import { Box } from '@material-ui/core';
import RadioButtonUncheckedIcon from '@material-ui/icons/RadioButtonUnchecked';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import FirstPageSharpIcon from '@material-ui/icons/FirstPageSharp';
import NavigateBeforeSharpIcon from '@material-ui/icons/NavigateBeforeSharp';
import NavigateNextSharpIcon from '@material-ui/icons/NavigateNextSharp';

const useStyles = makeStyles(() => ({
  root: {
    flexWrap: 'nowrap',
    margin: 'auto',
    '& div.MuiGrid-item': {
      padding: '10px 0',
      minWidth: '285px',
      width: '350px',
      '& h4': {
        color: '#000',
        padding: '12px 5px 12px 20px',
        fontSize: '16px',
        fontFamily: 'Conv_AtlasGrotesk-Regular-App',
        fontWeight: 'normal',
        lineHeight: '17px',
        textTransform: 'capitalize',
        textAlign: 'left',
      },
    },
  },
  paper: {
    width: 'auto',
    maxHeight: '350px',
    overflow: 'auto',
    '& .MuiList-padding': {
      padding: '10px',
    },
    '& div.MuiListItem-gutters': {
      padding: '0 10px 0 0',
      margin: '5px 0',
      borderBottom: '1px solid #cccccc50',
    },
    '& div.MuiListItemIcon-root': {
      '& span.MuiButtonBase-root': {
        '&:hover': {
          background: 'rgba(9, 89, 103, 0.06) ',
        },
      },
      '& svg.MuiSvgIcon-root': {
        color: '#000000 ',
      },
    },
    '& .MuiTypography-root': {
      wordBreak: 'break-all',
    },
  },
  buttonGroupHandle: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '20px',
    borderRight: '1px solid #cccccc40',
    borderLeft: '1px solid #cccccc40',
    '& div.MuiGrid-root': {
      flexDirection: 'column',
      gap: 60,
    },
  },
  navigate: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    gap: 10,
  },
  button: {
    fontSize: '20px',
    width: '40px',
    height: '40px',
    textAlign: 'center',
    color: '#000',
    textTransform: 'inherit',
    minWidth: 'auto',
    minHeight: 'auto',
    borderRadius: '6px',
    padding: '0',
    margin: '5px 0',
    border: 'none !important',
    '&:hover': {
      background: 'transparent',
      boxShadow: 'transparent',
    },
    '& .MuiButton-label': {
      fontSize: '12px',
      display: 'flex',
      flexDirection: 'column',
    },
  },
  popupModalSmallBtn: {
    padding: '10px 20px',
    borderTop: '2px solid #000',
    '& button': {
      fontSize: '14px',
      lineHeight: '42px',
      height: '42px',
      textAlign: 'center',
      color: '#fff',
      background: '#000',
      fontFamily: 'Conv_AtlasGrotesk-Medium-App',
      textTransform: 'inherit',
      marginLeft: '20px',
      borderRadius: '0px',
      '&:first-child': {
        color: '#000',
      },
      '&:hover': {
        background: '#000',
        boxShadow: 'none',
      },
    },
  },
  customRadio: {
    color: '#999',
    '&.Mui-checked': {
      color: '#000',
    },
  },
}));

function not(a, b) {
  return a.filter(aItem => !b.some(bItem => bItem.id === aItem.id));
}

function intersection(a, b) {
  return a.filter(aItem => b.some(bItem => bItem.id === aItem.id));
}

export default function TransferList({
  tenantsUsersList,
  saveMobileAccessPopup,
  cancelMobileAccessPopup,
}) {
  const leftData = tenantsUsersList?.filter(
    item => item.mobileAccess === false,
  );
  const rightData = tenantsUsersList?.filter(
    item => item.mobileAccess === true,
  );

  const [left, setLeft] = useState(leftData || []);
  const [right, setRight] = useState(rightData || []);

  const classes = useStyles();
  const [checked, setChecked] = useState([]);

  const leftChecked = intersection(checked, left);
  const rightChecked = intersection(checked, right);

  const handleToggle = user => () => {
    const currentIndex = checked.findIndex(item => item.id === user.id);
    const newChecked = [...checked];

    if (currentIndex === -1) {
      newChecked.push(user);
    } else {
      newChecked.splice(currentIndex, 1);
    }

    setChecked(newChecked);
  };

  const handleAllRight = () => {
    setRight(right.concat(left));
    setLeft([]);
    setChecked(not(checked, left));
  };

  const handleCheckedRight = () => {
    setRight(right.concat(leftChecked));
    setLeft(not(left, leftChecked));
    setChecked(not(checked, leftChecked));
  };

  const handleCheckedLeft = () => {
    setLeft(left.concat(rightChecked));
    setRight(not(right, rightChecked));
    setChecked(not(checked, rightChecked));
  };

  const handleAllLeft = () => {
    setLeft(left.concat(right));
    setRight([]);
    setChecked(not(checked, right));
  };

  const customList = items => (
    <div className={classes.paper}>
      <List dense component="div" role="list">
        {items.map(user => {
          const labelId = `transfer-list-item-${user.id}-label`;
          const isChecked = checked.some(item => item.id === user.id);

          return (
            <ListItem
              key={user.id}
              role="listitem"
              button
              onClick={handleToggle(user)}
            >
              <ListItemIcon>
                <Radio
                  checked={isChecked}
                  tabIndex={-1}
                  disableRipple
                  icon={<RadioButtonUncheckedIcon />}
                  checkedIcon={<CheckCircleIcon />}
                  inputProps={{ 'aria-labelledby': labelId }}
                  className={classes.customRadio}
                />
              </ListItemIcon>
              <ListItemText
                id={labelId}
                primary={`${user.firstName} ${user.lastName}`}
                secondary={user.email}
              />
            </ListItem>
          );
        })}
      </List>
    </div>
  );

  return (
    <div>
      <Grid container justifyContent="center" className={classes.root}>
        <Grid item>
          <h4>Disable Smart Keys</h4>
          {customList(left)}
        </Grid>
        <Grid className={classes.buttonGroupHandle}>
          <Grid
            container
            display="flex"
            flexDirection="column"
            alignItems="center"
            justifyContent="center"
            gap="40px"
          >
            <Box className={classes.navigate}>
              <Button
                variant="outlined"
                size="small"
                className={classes.button}
                onClick={handleAllRight}
                disabled={left.length === 0}
                aria-label="move all right"
              >
                <FirstPageSharpIcon
                  fontSize="medium"
                  style={{ transform: 'scaleX(-1)' }}
                />
                All
              </Button>
              <Button
                variant="outlined"
                size="small"
                className={classes.button}
                onClick={handleCheckedRight}
                disabled={leftChecked.length === 0}
                aria-label="move selected right"
              >
                <NavigateNextSharpIcon fontSize="medium" />
                Selected
              </Button>
            </Box>
            <Box className={classes.navigate}>
              <Button
                variant="outlined"
                size="small"
                className={classes.button}
                onClick={handleCheckedLeft}
                disabled={rightChecked.length === 0}
                aria-label="move selected left"
              >
                <NavigateBeforeSharpIcon fontSize="medium" />
                Selected
              </Button>
              <Button
                variant="outlined"
                size="small"
                className={classes.button}
                onClick={handleAllLeft}
                disabled={right.length === 0}
                aria-label="move all left"
              >
                <FirstPageSharpIcon fontSize="medium" />
                All
              </Button>
            </Box>
          </Grid>
        </Grid>
        <Grid item>
          <h4>Enable Smart Keys</h4>
          {customList(right)}
        </Grid>
      </Grid>
      <div className={`${classes.popupModalSmallBtn} popupModalSmallBtn`}>
        <Button onClick={() => cancelMobileAccessPopup()} color="primary">
          Cancel
        </Button>
        <Button
          onClick={() => saveMobileAccessPopup(left, right)}
          color="primary"
          autoFocus
        >
          Save
        </Button>
      </div>
    </div>
  );
}
